import PageLayout from '@/components/page/page-layout'

const DeviceList = () => import('@/views/device/list')
const ActivityCalendar = () => import('@/views/device/activity/calendar')

const router = {
  path: '/device',
  component: PageLayout,
  redirect: '/device/list',
  name: 'Device',
  icon: 'none',
  children: [
    {
      path: 'list',
      name: 'deviceList',
      component: DeviceList,
      meta: {
        currentMenu: 'device',
        hideBreadcrumb: true,
        title: '设备管理'
      }
    },
    {
      path: 'activity/calendar',
      name: 'activityCalendar',
      component: ActivityCalendar,
      meta: {
        currentMenu: 'device',
        hideBreadcrumb: true,
        title: '活动计划'
      }
    }
  ]
}

export default router
